import { initNavbar } from "./navbar";
import { initAccordion } from "./accordion";
import { initImageModal } from "./imageModal";

function run() {
  initNavbar();
  initAccordion();
  initImageModal();
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", run, { once: true });
} else {
  run();
}
